import React, { useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import { Box, FormControl, Button, TextField } from "@material-ui/core";
import CardContent from "@material-ui/core/CardContent";
import Select from "@material-ui/core/Select";
import List from "@material-ui/core/List";
import Typography from "@material-ui/core/Typography";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import ListItemText from "@material-ui/core/ListItemText";
import MyGallery from "./ImageGallery";
import MenuItem from "@material-ui/core/MenuItem";
import { arbitrationReview, arbitrationAdminStatusHistory, arbitrationStatusUpdateApi } from "../service/api";
import Loaderpage from "../pages/LoaderPage";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import { convertBase64ToArray, generateFileUrl } from "../Utils/utils";


export default function ArbitrationReviewpage(props) {
  const arbitrationId = props?.location?.state?.item?.arbitration_id;
  const [arbitrationDetails, setArbitrationDetails] = React.useState({});
  const [arbitrationDetailsReason, setArbitrationDetailsReason] = React.useState([]);
  const [arbitrationAdminStatusHistoryDetails, setArbitrationAdminStatusHistoryDetails] = React.useState('');
  const [arbitrationInspectionsDetails, setArbitrationInspectionsDetails] = React.useState([]);
  const [arbitrationStatus, setArbitrationStatus] = React.useState([]);
  const [arbitrationStatusReason, setArbitrationStatusReason] = React.useState([]);
  const [adminNoteVal, setAdminNoteVal] = React.useState('');
  const [statusUpdateVal, setStatusUpdateVal] = React.useState('');
  const [reasonUpdateVal, setReasonUpdateVal] = React.useState('');
  const [arbitrationImage, setArbitrationImage] = React.useState([]);
  const [loader, setLoader] = React.useState(true);
  const [arbitrationHistryLoader, setArbitrationHistryLoader] = React.useState(true);
  const [arbitrationStatusUpdate, setArbitrationStatusUpdate] = React.useState(0);
  const [updatedArbitrationStatusReason, setUpdatedArbitrationStatusReason] = React.useState([]);

  useEffect(async () => {
    getArbitrationDetails(arbitrationId);
    getArbitrationAdminStatusHistory(arbitrationId);
  }, []);

  const getArbitrationDetails = async (arbitrationId) => {
    const arbitrationReviewData = await arbitrationReview(arbitrationId);
    setArbitrationDetails(arbitrationReviewData?.data?.arbitration);
    setArbitrationDetailsReason(arbitrationReviewData?.data?.arbitrationReason);
    setArbitrationInspectionsDetails(arbitrationReviewData?.data?.vinInspection);
    setArbitrationStatus(arbitrationReviewData?.data?.arbitrationStatus)
    setArbitrationStatusReason(arbitrationReviewData?.data?.arbitrationStatusReason);
    if (arbitrationReviewData?.data?.arbitrationImage) arrangeImages(arbitrationReviewData?.data?.arbitrationImage);
    setLoader(false);
  }

  const getArbitrationAdminStatusHistory = async (arbitrationId) => {
    setArbitrationHistryLoader(true);
    const arbitrationAdminStatusHistoryData = await arbitrationAdminStatusHistory(arbitrationId);
    if (arbitrationAdminStatusHistoryData?.data) {
      const arbitrationDataString = arbitrationAdminStatusHistoryData?.data;
      const arbitrationHistyStrng = !arbitrationDataString?.success && arbitrationDataString?.indexOf('arbitrationStatusHistory') >= 0 ? arbitrationDataString.split('arbitrationStatusHistory')[1]?.replace('":"', '') : '';
      setArbitrationAdminStatusHistoryDetails(arbitrationHistyStrng?.replace('"}', '')?.trim());
    }
    setArbitrationHistryLoader(false);

  }

  const setArbitrationStatusFunc = async () => {
    const data = {
      "arbitrationId": arbitrationId,
      "status": statusUpdateVal,
      "statusNotes": adminNoteVal,
      "statusReason": reasonUpdateVal
    }
    const arbitrationStatusUpdateData = await arbitrationStatusUpdateApi(data);
    if (arbitrationStatusUpdateData?.data?.success === "TRUE") {
      setArbitrationStatusUpdate(1);
      getArbitrationAdminStatusHistory(arbitrationId);
      getArbitrationDetails(arbitrationId);
      resetSubmitAction();
    } else {
      setArbitrationStatusUpdate(2);
      setLoader(false);
    }
  };

  const openConditionReport = (VINumber, vehicle) => {
    const dataObj = {
      vin: VINumber,
      purchaseSection: false,
      vehicleDetails: vehicle,
    };
    const prefix = window.location.href && window.location.href.split('/');
    const nextUrl = window.location.href.replace(prefix[prefix?.length - 1], 'conditionreportRequests');
    const encodedData = btoa(JSON.stringify(dataObj));
    window.open(`${nextUrl}/${encodedData}`, '_blank');
  };

  const arrangeImages = (images) => {
    let imagesdata = [];
    for (let img of images) {
      let imgobj = {
        original: img.fileName.endsWith(".pdf") ? "data:application/pdf;base64," + img?.imageBinValue : "data:image/jpeg;base64," + img?.imageBinValue,
        thumbnail: img.fileName.endsWith(".pdf") ? "data:application/pdf;base64," + img?.imageBinValue : "data:image/jpeg;base64," + img?.imageBinValue,
        damageDescription: img?.fileName,
      };
      imagesdata.push(imgobj);
    }
    setArbitrationImage([...imagesdata]);
  };
  const arbitrationImagesHandle = {
    arbitration: true,
    arbitrationImages: arbitrationImage
  };

  const resetSubmitAction = () => {
    setReasonUpdateVal('');
    setStatusUpdateVal('');
    setAdminNoteVal('');
  };

  const setReasonUpdatedList = (value) => {
    setReasonUpdateVal('');
    const list = [];
    arbitrationStatusReason?.map((item) => {
      if (item?.statusReason?.toLowerCase()?.indexOf(value?.toLowerCase()) >= 0) {
        return list.push(item);
      }
      return null;
    })
    setUpdatedArbitrationStatusReason(list)
  }

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  });

  const dateFormat = (value) => {
    let dateVal = '';
    if (value?.indexOf('T') >= 0) {
      const date = value?.split('T')[0];
      const val = date?.split('-');
      const dateUpdate = `${val[1]}/${val[2]}/${val[0]}`;
      dateVal = `${dateUpdate} ${value?.split('T')[1]}`
    }
    return dateVal;
  }

  const handle = (input, type) => {
    var sampleArr = convertBase64ToArray(input);
    return generateFileUrl(sampleArr, type);
  }

  return (
    <>
      <div className="myContainerLayout">
        {!loader &&
          <><div className="conditionPageCard">
            <Grid>
              <div className="conditionTopBar">
              </div>
            </Grid>
            {arbitrationDetails && !loader && (
              <Box px={2}>
                <Grid container spacing={3} className="ConditionCardReportSpace">
                  <Grid item xs={5}>
                    {arbitrationImagesHandle?.arbitrationImages?.length > 0 && <div className="codereportimggallery">
                      <MyGallery {...arbitrationImagesHandle} />
                    </div>}
                    <Card className="vehicleSectionCR">
                      {arbitrationImagesHandle?.arbitrationImages?.length > 0 &&
                        <>
                          <Typography variant="h6" className="vehicleDetailsMargin">
                            Attachments
                            <hr />
                          </Typography>
                          <CardContent>
                            <List className="paddingCSS-arbitrationReview">
                              <ListItemText>
                                <ul style={{ listStyleType: "none", padding: 0 }}>
                                  {arbitrationImagesHandle?.arbitrationImages.map((file, index) => (
                                    <span className="textSize inspectionData">
                                      <a download={file?.damageDescription} href={handle(file?.original?.split(',')[1], file?.original?.split(',')[0].split(':')[1])} style={{ textDecoration: "none" }}>{file?.damageDescription}</a>
                                    </span>
                                  ))}
                                </ul>
                              </ListItemText>
                            </List>
                          </CardContent>
                        </>}
                      <Typography variant="h6" className="vehicleDetailsMargin">
                        Inspections
                        <hr />
                      </Typography>
                      <CardContent>
                        <List className="paddingCSS-arbitrationReview">
                          <ListItemText>
                            {arbitrationInspectionsDetails?.map((item) => {
                              const updatedInspectiondata = item?.inspectionDate && item?.inspectionDate?.indexOf(' ') > 0 ? item?.inspectionDate?.split(' ')[0] : item?.inspectionDate ? item?.inspectionDate : '';
                              return (
                                <span className="textSize inspectionData">
                                  {<a href
                                    className="vin"
                                    onClick={() => openConditionReport(arbitrationDetails?.vin, arbitrationDetails)}>{item?.inspectionId}</a>}{' '}&nbsp;{item?.inspectionType},{' '}{updatedInspectiondata}
                                </span>
                              );
                            })}
                          </ListItemText>
                        </List>
                      </CardContent>
                      <Typography variant="h6" className="vehicleDetailsMargin">
                        Admin Status History
                        <hr />
                      </Typography>
                      <CardContent>
                        <List className="paddingCSS-arbitrationReview">
                          {arbitrationAdminStatusHistoryDetails?.length > 0 && !arbitrationHistryLoader ? <TextareaAutosize
                            disabled
                            maxRows={8}
                            className="inputFieldTextAreaArbitrationReview"
                            aria-label="maximum height"
                            defaultValue={arbitrationAdminStatusHistoryDetails} /> :
                            <Box
                              height={"350px"}
                              display={"flex"}
                              justifyContent={"center"}
                              alignItems={"center"}
                            >
                              <div>
                                <Loaderpage />
                                <span className="loaderText">Loading...</span>
                              </div>
                            </Box>}
                        </List>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item xs={7}>
                    <Grid container spacing={1}>
                      <div className="ConditionReportSection">
                        <Grid item>
                          <div className="reportTitle">
                            <span>
                              {arbitrationDetails && arbitrationDetails?.modelYear}{" "}
                              {arbitrationDetails && arbitrationDetails?.brand}{" "}
                              {arbitrationDetails && arbitrationDetails?.model}{" "}
                              {arbitrationDetails && arbitrationDetails?.extColor}{" "}
                            </span>
                          </div>
                        </Grid>
                        <Grid item>
                          <span className="reportVhcleTitle">
                            {arbitrationStatus && arbitrationStatus?.map((item) => {
                              let element = '';
                              if (item?.currentStatus !== null) {
                                const inspectionBadgeClass = item?.listStatus !== 'Closed' ? 'ConditionReportInspectionPending' : 'ConditionReportInspection';
                                element = <span className={`BadgeValue ${inspectionBadgeClass}`}>
                                  {item?.listStatus}
                                </span>
                              }
                              return element;
                            })}
                          </span>
                        </Grid>
                      </div>
                    </Grid>
                    <Grid container spacing={3}>
                      <Card className="vehicleSectionCR arbitrationReviewRightPanel">
                        <Typography variant="h6" className="vehicleDetailsMargin">
                          Arbitration Details
                          <hr />
                        </Typography>
                        <CardContent>
                          <List className="paddingCSS-arbitrationReview">
                            <div className="dealerNoteStyle">
                              <div>
                                <span className="textStyle">
                                  <span className="textBold"> VIN </span>
                                </span>
                              </div>
                              <div className="rightPanelDataRight">
                                <span className="textSize">{arbitrationDetails?.vin}</span>
                              </div>
                            </div>
                          </List>
                          <List className="paddingCSS-arbitrationReview">
                            <div className="dealerNoteStyle">
                              <div>
                                <span className="textStyle">
                                  <span className="textBold">
                                    Arbitration Id
                                  </span>
                                </span>
                              </div>
                              <div className="rightPanelDataRight">
                                <span className="textSize">
                                  {arbitrationDetails?.arbitrationId}
                                </span>
                              </div>
                            </div>
                          </List>
                          <List className="paddingCSS-arbitrationReview">
                            <div className="dealerNoteStyle">
                              <div>
                                <span className="textStyle">
                                  <span className="textBold">
                                    Arbitration Date
                                  </span>
                                </span>
                              </div>
                              <div className="rightPanelDataRight">
                                <span className="textSize">
                                  {dateFormat(arbitrationDetails?.arbitrationDate)}
                                </span>
                              </div>
                            </div>
                          </List>
                          <List className="paddingCSS-arbitrationReview">
                            <div className="dealerNoteStyle">
                              <div>
                                <span className="textStyle">
                                  <span className="textBold">
                                    Dealer
                                  </span>
                                </span>
                              </div>
                              <div className="rightPanelDataRight">
                                <span className="textSize">
                                  {arbitrationDetails?.dealerNumber} - {arbitrationDetails?.dealerName}
                                </span>
                              </div>
                            </div>
                          </List>
                          <List className="paddingCSS-arbitrationReview">
                            <div className="dealerNoteStyle">
                              <div>
                                <span className="textStyle">
                                  <span className="textBold">
                                    Location
                                  </span>
                                </span>
                              </div>
                              <div className="rightPanelDataRight">
                                <span className="textSize locationData addressData">
                                  {arbitrationDetails?.locationType && arbitrationDetails?.locationType.toLowerCase()}
                                  <p>{arbitrationDetails?.locationAddress && arbitrationDetails?.locationAddress.toLowerCase()}</p>
                                  <p>{arbitrationDetails?.locationAddress2 && arbitrationDetails?.locationAddress2.toLowerCase()}</p>
                                  <p>{arbitrationDetails?.locationCity && arbitrationDetails?.locationCity.toLowerCase()},
                                    {arbitrationDetails?.locationState && arbitrationDetails?.locationState.toLowerCase()}-
                                    {arbitrationDetails?.locationZip && arbitrationDetails?.locationZip.toLowerCase()}</p>
                                  <p>{arbitrationDetails?.locationPhone && arbitrationDetails?.locationPhone.toLowerCase()}</p>
                                  <p>{arbitrationDetails?.locationEmail && arbitrationDetails?.locationEmail.toLowerCase()}</p>
                                </span>
                              </div>
                            </div>
                          </List>
                          <List className="paddingCSS-arbitrationReview">
                            <div className="dealerNoteStyle">
                              <div>
                                <span className="textStyle adminNoteHeading">
                                  <span className="textBold adminNoteHeading"> Dealer Notes </span>
                                </span>
                              </div>
                              <div className="rightPanelDataRight">
                                {arbitrationDetails?.dealerNotes && <div className="dealerNotesData">{arbitrationDetails?.dealerNotes}</div>}
                              </div>
                            </div>
                          </List>
                          <List className="paddingCSS-arbitrationReview">
                            <div className="dealerNoteStyle">
                              <div>
                                <span className="textStyle">
                                  <span className="textBold"> Reasons </span>
                                </span>
                              </div>
                              <div className="rightPanelDataRight">
                                {arbitrationDetailsReason?.map((item) => {
                                  return (
                                    <span className="textSize locationData">
                                      {item?.reasonType} : {item?.reason}
                                    </span>
                                  );
                                })}
                              </div>
                            </div>
                          </List>
                          <List className="paddingCSS-arbitrationReview">
                            <div className="dealerNoteStyle">
                              <div>
                                <span className="textStyle">
                                  <span className="textBold"> Purchase Amount </span>
                                </span>
                              </div>
                              <div className="rightPanelDataRight">
                                <span className="textSize">
                                  {arbitrationDetails?.purchaseAmount && formatter.format(arbitrationDetails?.purchaseAmount)}
                                </span>
                              </div>
                            </div>
                          </List>
                          <List className="paddingCSS-arbitrationReview">
                            <div className="dealerNoteStyle">
                              <div>
                                <span className="textStyle">
                                  <span className="textBold"> Purchase Date </span>
                                </span>
                              </div>
                              <div className="rightPanelDataRight">
                                <span className="textSize">
                                  {dateFormat(arbitrationDetails?.purchaseDate)}
                                </span>
                              </div>
                            </div>
                          </List>
                        </CardContent>
                        <CardContent>
                          <Typography variant="h6">Admin Status Update</Typography>
                          <hr />
                          <TableContainer component={Paper}>
                            <Table
                              className="table"
                              size="small"
                              aria-label="a dense table"
                            >
                              <TableBody>
                                <TableRow>
                                  <TableCell component="th" scope="row">
                                    Status
                                  </TableCell>
                                  <TableCell align="right">
                                    <FormControl className="formControl" style={{
                                      minWidth: '226px'
                                    }} variant="outlined">
                                      <Select
                                        labelId="demo-customized-select-label"
                                        id="demo-customized-select"
                                        setAdminNoteVal
                                        autoWidth
                                        onChange={(e) => {
                                          setStatusUpdateVal(e?.target?.value);
                                          setArbitrationStatusUpdate(0);
                                          setReasonUpdatedList(e?.target?.value);
                                        }}
                                        value={statusUpdateVal}
                                      >
                                        {arbitrationStatus &&
                                          arbitrationStatus.map((menuitem) => {
                                            return (
                                              <MenuItem value={menuitem?.listStatus}>
                                                {" "}
                                                {menuitem?.listStatus}
                                              </MenuItem>
                                            );
                                          }
                                          )}
                                      </Select>
                                    </FormControl>
                                  </TableCell>
                                </TableRow>
                                <TableRow>
                                  <TableCell component="th" scope="row">
                                    Reason
                                  </TableCell>
                                  <TableCell align="right">
                                    <FormControl className="formControl" variant="outlined">
                                      <Select
                                        labelId="demo-customized-select-label"
                                        id="demo-customized-select"
                                        onChange={(e) => {
                                          setReasonUpdateVal(e?.target?.value);
                                          setArbitrationStatusUpdate(0);
                                        }}
                                        value={reasonUpdateVal}
                                        disabled={updatedArbitrationStatusReason?.length > 0 ? false : true}
                                      >
                                        {updatedArbitrationStatusReason &&
                                          updatedArbitrationStatusReason.map((menuitem) => {
                                            return (
                                              <MenuItem value={menuitem?.statusReason}>
                                                {" "}
                                                {menuitem?.statusReason}
                                              </MenuItem>
                                            );
                                          }
                                          )}
                                      </Select>
                                    </FormControl>
                                  </TableCell>
                                </TableRow>
                                <TableRow>
                                  <TableCell component="th" scope="row" className="adminNoteHeading">
                                    Admin Notes
                                  </TableCell>
                                  <TableCell align="left">
                                    <TextField
                                      className="notesText notesTextContent"
                                      value={adminNoteVal}
                                      rows={6}
                                      multiline
                                      label="Admin Notes..."
                                      variant="outlined"
                                      inputProps={{ maxLength: 500 }}
                                      onChange={(e) => {
                                        setAdminNoteVal(e.target.value);
                                        setArbitrationStatusUpdate(0);
                                      }} />
                                  </TableCell>
                                </TableRow>
                              </TableBody>
                            </Table>
                          </TableContainer>
                          <div className="arbitrationSubmit">
                            {((statusUpdateVal !== '' && adminNoteVal !== '' && reasonUpdateVal !== '') || (statusUpdateVal?.toLowerCase() !== 'denied' && adminNoteVal !== '')) ? <Button onClick={() => { setArbitrationStatusFunc(); }} variant="contained" style={{ height: '38px' }} color="primary">
                              Submit
                            </Button> : <Button variant="contained" disabled>Submit</Button>}
                            {arbitrationStatusUpdate === 2 && <><div style={{ color: 'red' }}>Please adjust the arbitration Settings.</div> <br /></>}
                            {arbitrationStatusUpdate === 1 && <><div style={{ color: '#00C6B7' }}>Successfully Updated the Admin Status.</div> <br /></>}
                          </div>

                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            )}
            {loader ? (
              <Box
                height={"350px"}
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
              >
                <div>
                  <Loaderpage />
                  <span className="loaderText">Loading...</span>
                </div>
              </Box>
            ) : (
              ""
            )}
          </div><div className="purchasesidebar">
              {(""
              )}
            </div></>
        }
      </div >
    </>
  );
}


